export const isSettingsModulePath = () => {
  const settingsPaths = ['/settings#', '/settings/user#']
  return settingsPaths.some((path) => window.location.href.includes(path))
}
